import { TFunction } from 'i18next';
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const SUPPORTED_FILE_TYPES = [
  'image/gif',
  'image/png',
  'image/jpg',
  'image/jpeg',
];
export const IMAGE_QUALITY = 0.4;
export const compositeLimit = 10;

export const PRODUCT_DISPLAY_LIMIT = 25;

export const DISPLAY_IMAGE_SIZE = 80;
export const DISPLAY_COMPOSITE_IMAGE_SIZE = 50;
export const SELECTED_TAGS_LIMIT = 5;
export const LEAST_SEARCH_LENGTH = 2;
export const LEAST_CREATE_NEW_TAG_LENGTH = 2;

export const unitPriceFields = [
  { id: 0, fieldName: 'unit_price' },
  { id: 1, fieldName: 'unit_price1' },
  { id: 2, fieldName: 'unit_price2' },
  { id: 3, fieldName: 'unit_price3' },
  { id: 4, fieldName: 'unit_price4' },
];

export const InventoryTypes = (t: TFunction) => [
  {
    options: [
      { label: t('ProductField_Inventory_option_0'), value: '0' },
      { label: t('ProductField_Inventory_option_1'), value: '1' },
      { label: t('ProductField_Inventory_option_2'), value: '2' },
      {
        label: t('ProductField_Inventory_option_3'),
        value: '3',
      },
    ],
  },
];
export const ProductStockTypes = (t: TFunction) => [
  { label: t('ProductField_Items_have_stock'), value: '0' },
  { label: t('ProductField_Items_without_stock'), value: '1' },
];
export const UnitTypes = (t: TFunction) => [
  { label: t('ProductField_Piece'), value: '0' },
  { label: t('ProductField_Weight'), value: '1' },
];

export const ProductColumnWidthStyle = {
  images: {
    maxWidth: '360px',
    minWidth: '320px',
  },
  code: {
    maxWidth: '150px',
    minWidth: '120px',
  },
  tags: {
    maxWidth: '120px',
    minWidth: '100px',
  },
  barcode: {
    maxWidth: '150px',
    minWidth: '100px',
  },
};
export const ProductColumnWidthMobileStyle = {
  images: {
    maxWidth: '300px',
    minWidth: '250px',
  },
  code: {
    maxWidth: '100px',
    minWidth: '80px',
  },
  tags: {
    maxWidth: '100px',
    minWidth: '70px',
  },
  barcode: {
    maxWidth: '100px',
    minWidth: '80px',
  },
};
export const ProductListButtonIconSize = '20px';
export const ProductListActionButtons = {
  button: {
    width: '30px',
    height: '30px',
  },
  icon: '20px',
};

export const getProductColumnWidth = (
  isMobile: boolean,
  id: keyof typeof ProductColumnWidthStyle,
  type: 'minWidth' | 'maxWidth'
): string | undefined => {
  const styleMap = isMobile
    ? ProductColumnWidthMobileStyle
    : ProductColumnWidthStyle;

  return styleMap[id]?.[type];
};

export const ProductTableColumnWidth = {
  id: '5%',
  images: '15%',
  code: '10%',
  barcode: '10%',
  // category_name: '5%',
  // name: '10%',
  cost_price: '5%',
  unit_price: '5%',
  quantity: '5%',
  store_id: '5',
  action: '5%',
};
export const ProductTableColumnWidthMobile = {
  id: '5%',
  images: '5%',
  code: '5%',
  barcode: '5%',
  // category_name: '5%',
  // name: '10%',
  cost_price: '5%',
  unit_price: '5%',
  quantity: '5%',
  store_id: '5',
  action: '5%',
};

export const TextColumnsStyle = {
  cost_price: 'text-end',
  unit_price: 'text-end',
  quantity: 'text-center',
};
